export enum SpellCastingTypes {
    Innate = 'Innate',
    Focus = 'Focus',
    Spontaneous = 'Spontaneous',
    Prepared = 'Prepared',
}
